var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guests"},[_c('statisticCard',{attrs:{"icon":'mdi-account-plus',"color":'red',"statistic":_vm.statistic.from_start_count,"description":'אברכים נוספים'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }